import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageLink',
  props: {
    isMultilingual: { type: Boolean, default: true }
  },
  emits: ['set-locale'],
  setup(__props: any) {




const i18n = useI18n()
// Use the opposite locale of the current global setting so that the language
// link is translated in the resulting locale so it's easy to read (eg English
// link text while the site is in spanish and Español while in english)
const locale = computed(() => i18n.locale.value === 'en' ? 'es' : 'en')
const keyMap = {
  en: 'topnav.english',
  es: 'topnav.spanish',
}
const key = computed(() => keyMap[locale.value] || 'my-settings.language.label')

return (_ctx: any,_cache: any) => {
  const _component_b_link = _resolveComponent("b-link")!

  return (_ctx.isMultilingual)
    ? (_openBlock(), _createBlock(_component_b_link, {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('set-locale', locale.value)))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(key.value, {}, {locale: locale.value})), 1)
        ], undefined, true),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})